var _path, _path2, _ellipse, _g, _g2, _path3, _path4, _g3, _g4, _path5, _ellipse2, _g5, _g6, _path6, _ellipse3, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _path7, _g15, _g16, _path8, _g17, _g18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 93,
    viewBox: "0 0 133 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.7418 75.4651C103.297 73.8492 113.425 69.383 117.083 66.0384C121.297 62.5416 112.671 58.4941 111.649 57.887C110.626 57.2799 60.3468 31.7067 51.5721 27.7389C42.7974 23.7711 14.8044 31.6705 8.00817 35.3536C2.46844 38.3558 6.33936 40.5583 7.06781 41.1624C7.79626 41.7666 49.6532 65.6535 64.7113 72.9671C76.1148 78.5057 86.8379 78.6367 97.7418 75.4651Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0488 48.7427L63.6655 46.2069L63.6676 46.2116C63.7014 46.1957 63.7355 46.1802 63.7699 46.1652C67.115 44.7046 71.8313 48.1383 74.3039 53.8347C76.7765 59.5311 76.0692 65.333 72.7241 66.7937C72.6683 66.818 72.6122 66.841 72.5557 66.8627L67.175 69.2954L64.2633 62.7382C63.4793 61.682 62.7724 60.4658 62.1901 59.1242C61.6526 57.8861 61.2654 56.643 61.0229 55.4405L58.0488 48.7427Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.61181,
    cy: 11.2307,
    rx: 6.61181,
    ry: 11.2307,
    transform: "matrix(-0.916076 0.399994 0.398342 0.917677 64.2703 46.0498)",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_608_176)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.95909,
    cy: 8.42342,
    rx: 4.95909,
    ry: 8.42342,
    transform: "matrix(-0.916076 0.399994 0.398342 0.917677 63.6821 49.2891)",
    fill: "url(#paint0_linear_608_176)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.4656 53.5133C63.9261 53.8853 64.3727 54.3403 64.7886 54.866L63.4285 57.1742L63.4656 53.5133ZM63.3726 62.6933L64.9753 65.5436C64.4634 65.6909 63.9097 65.6717 63.3441 65.5077L63.3726 62.6933ZM62.3429 65.0742L62.3804 61.3703C62.3189 61.3327 62.2576 61.2911 62.1968 61.2457L60.7164 63.758C61.2345 64.3095 61.786 64.755 62.3429 65.0742ZM62.4285 56.6309L62.4668 52.8494C61.5053 52.345 60.5364 52.2224 59.7038 52.5859C59.4716 52.6873 59.2598 52.8222 59.0689 52.9868L61.1632 56.7117C61.2374 56.6477 61.3197 56.5952 61.41 56.5558C61.7176 56.4215 62.0731 56.4582 62.4285 56.6309ZM65.8656 65.0747L63.8008 61.4026C63.9078 61.315 63.9986 61.204 64.0727 61.0738L67.0605 62.8445C66.8707 63.8 66.4678 64.5812 65.8656 65.0747ZM60.8811 59.3074C60.864 59.2561 60.848 59.2049 60.833 59.1539L57.8418 57.3812C57.9228 58.1988 58.1178 59.0653 58.4318 59.9391L60.8811 59.3074ZM64.2702 59.473C64.3011 59.6712 64.3153 59.8636 64.3133 60.0465L67.182 61.7466C67.2107 60.8445 67.0834 59.847 66.7916 58.8228L64.2702 59.473ZM66.4729 57.8653L63.9971 58.5038C63.9841 58.4722 63.9708 58.4406 63.9571 58.409C63.9446 58.3802 63.9319 58.3516 63.9189 58.3233L65.4256 55.7663C65.7362 56.257 66.0199 56.7909 66.2675 57.3613C66.3404 57.5293 66.4089 57.6974 66.4729 57.8653ZM61.4753 60.4889L60.0312 62.9396C59.5773 62.3331 59.1643 61.6407 58.8157 60.8797L61.3098 60.2365C61.3629 60.324 61.4181 60.4083 61.4753 60.4889ZM60.6706 57.8877L57.8056 56.1898C57.8444 55.2818 58.0432 54.474 58.3933 53.8375L60.6706 57.8877Z",
    fill: "#4C4C4C"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0503 48.6233L63.667 46.0875L63.6685 46.0908C63.7035 46.0743 63.7389 46.0582 63.7746 46.0426C67.1197 44.582 71.8359 48.0157 74.3085 53.7122C76.7811 59.4086 76.0738 65.2105 72.7287 66.6712C72.6813 66.6919 72.6337 66.7115 72.5859 66.7303L67.1765 69.176L64.2567 62.6005C63.4771 61.5478 62.7743 60.3369 62.1947 59.0017C61.6601 57.77 61.2742 56.5335 61.0314 55.3369L58.0503 48.6233Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5615 61.507C59.0323 67.199 63.747 70.6291 67.0921 69.1685C70.4373 67.7079 71.1461 61.9096 68.6754 56.2177C66.2047 50.5257 61.3501 46.7891 58.005 48.2497C54.6598 49.7103 54.0908 55.8151 56.5615 61.507Z",
    fill: "black"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_608_176)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.64802,
    cy: 8.1228,
    rx: 4.64802,
    ry: 8.1228,
    transform: "matrix(-0.912075 0.410172 0.38523 0.922806 63.6624 49.6016)",
    fill: "url(#paint1_linear_608_176)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7104 62.6558C61.0245 63.0577 61.3585 63.4096 61.7021 63.7039L61.1763 62.469L60.7104 62.6558ZM59.2462 59.986C58.8035 58.7836 58.6124 57.5903 58.6559 56.5502L59.9917 59.6871L59.2462 59.986ZM63.9931 58.0827C63.4359 56.9059 62.5304 56.1474 61.7732 56.1842L60.5601 53.3354C62.2309 52.9091 64.4065 54.6443 65.6219 57.4297L63.9931 58.0827ZM66.4112 60.3701C66.5888 62.1334 66.1769 63.6376 65.241 64.328L64.0281 61.4796C64.0877 61.4147 64.1414 61.3415 64.1891 61.261L66.4112 60.3701Z",
    fill: "#474747"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2127 39.4563C18.7392 38.4888 18.3507 37.4056 18.0796 36.2406C17.8297 35.1664 17.6999 34.11 17.6794 33.1068L16.2523 27.1975L21.1627 25.9808C21.2041 25.9693 21.2459 25.9586 21.288 25.9488C24.2222 25.2602 27.5431 28.7516 28.7054 33.7471C29.8676 38.7425 28.4312 43.3503 25.497 44.0389C25.4847 44.0418 25.4725 44.0446 25.4602 44.0473L25.4603 44.0476L20.6123 45.2517L19.2127 39.4563Z",
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.46047,
    cy: 9.27384,
    rx: 5.46047,
    ry: 9.27384,
    transform: "matrix(-0.972968 0.228322 0.226758 0.974567 21.7026 25.9297)",
    fill: "black"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_608_176)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.09555,
    cy: 6.95571,
    rx: 4.09555,
    ry: 6.95571,
    transform: "matrix(-0.972968 0.228322 0.226758 0.974567 20.7473 28.4727)",
    fill: "url(#paint2_linear_608_176)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_di_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9416 31.8682C20.2613 32.2396 20.5574 32.6768 20.8178 33.1671L19.3661 34.8442L19.9416 31.8682ZM18.5024 39.3113L19.3818 41.8683C18.9437 41.9115 18.4963 41.813 18.0608 41.5949L18.5024 39.3113ZM17.3121 41.0931L17.8924 38.0921C17.8486 38.0528 17.8055 38.0105 17.7634 37.9652L16.189 39.7841C16.5273 40.3081 16.9082 40.7512 17.3121 41.0931ZM18.6355 34.2489L19.2288 31.181C18.5233 30.6294 17.7554 30.3863 17.0258 30.5575C16.8218 30.6054 16.6294 30.6836 16.4495 30.7892L17.5973 34.1264C17.6669 34.0856 17.7413 34.0554 17.8202 34.0369C18.0897 33.9736 18.3728 34.0561 18.6355 34.2489ZM20.1747 41.6204L19.0431 38.3301C19.1433 38.2746 19.2337 38.1976 19.3134 38.1024L21.4777 39.9859C21.1815 40.7343 20.7377 41.3092 20.1747 41.6204ZM16.9819 36.1954C16.9754 36.1496 16.9699 36.1041 16.9652 36.0589L14.8011 34.1756C14.7453 34.8526 14.7751 35.5863 14.9007 36.3438L16.9819 36.1954ZM19.7103 36.8345C19.7059 36.9987 19.6891 37.1557 19.6607 37.3029L21.7395 39.112C21.8967 38.3842 21.9415 37.556 21.857 36.6815L19.7103 36.8345ZM21.7405 35.8562L19.6329 36.0065C19.627 35.9783 19.6207 35.95 19.6141 35.9217C19.6084 35.8969 19.6024 35.8723 19.5962 35.8478L21.2014 33.9932C21.3807 34.4379 21.5318 34.9137 21.6481 35.4137C21.6826 35.5619 21.7134 35.7094 21.7405 35.8562ZM17.2895 37.2434L15.754 39.0174C15.4756 38.4577 15.2432 37.8345 15.073 37.1651L17.1926 37.014C17.2227 37.0929 17.2551 37.1695 17.2895 37.2434ZM17.0218 35.0065L14.9486 33.2023C15.1149 32.4711 15.3961 31.8449 15.7746 31.3801L17.0218 35.0065Z",
    fill: "#4C4C4C"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2372 27.3194L21.1763 26.0956L21.1773 26.0997C21.2074 26.0917 21.2377 26.0842 21.2681 26.077C24.2023 25.3885 27.5232 28.8799 28.6855 33.8753C29.8478 38.8708 28.4114 43.4786 25.4772 44.1671C25.4282 44.1786 25.3792 44.1889 25.3301 44.1981L20.5972 45.3736L19.2053 39.6098C18.7261 38.636 18.3332 37.544 18.0598 36.3689C17.8075 35.2845 17.6776 34.2184 17.659 33.2066L16.2372 27.3194Z",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.52115,
    cy: 9.37689,
    rx: 5.52115,
    ry: 9.37689,
    transform: "matrix(-0.972968 0.228322 0.226758 0.974567 21.724 25.8359)",
    fill: "black"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_608_176)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_608_176)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.84223,
    cy: 6.71606,
    rx: 3.84223,
    ry: 6.71606,
    transform: "matrix(-0.958851 0.281681 0.294714 0.956218 19.8508 29.3467)",
    fill: "url(#paint3_linear_608_176)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_di_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1327 39.606C16.3233 39.9288 16.5309 40.2219 16.7504 40.4799L16.494 39.5321L16.1327 39.606ZM15.1928 37.1685C14.9721 36.1562 14.9495 35.1857 15.096 34.3639L15.82 37.0402L15.1928 37.1685ZM20.7593 36.0302C20.0812 33.606 18.4867 31.8898 17.0563 31.9905L17.7257 34.4651C18.3565 34.5438 19.0175 35.2881 19.3406 36.3203L20.7593 36.0302ZM21.0634 38.5977C20.9882 40.0069 20.4761 41.1249 19.6391 41.5387L18.9706 39.0672C18.9929 39.0501 19.0147 39.0318 19.0358 39.0123L21.0634 38.5977Z",
    fill: "url(#paint4_linear_608_176)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ii_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9002 25.2296C90.1376 25.3761 90.3485 25.4778 90.5338 25.5294C92.6038 26.1059 109.894 35.8157 113.646 39.6853C117.298 43.4509 117.07 45.6773 116.965 46.7108C116.95 46.8601 116.937 46.9845 116.939 47.085C116.948 47.5865 116.934 48.5953 116.917 49.8787C116.906 50.6346 116.894 51.4858 116.885 52.3847L116.854 55.4387C116.845 55.6668 116.843 55.8996 116.842 56.1373C116.836 57.1466 116.83 58.244 116.199 59.4401C115.421 60.9145 111.682 66.3115 93.7504 71.7445C87.6483 73.5932 80.6003 71.3847 76.1321 69.4744C74.7971 68.9599 73.6978 68.4613 72.9303 68.0916C72.7124 67.9866 72.5221 67.8432 72.3627 67.6719C72.2542 67.6147 72.157 67.5631 72.0717 67.5178C71.9759 67.4669 71.8951 67.424 71.83 67.39C71.7312 65.8477 71.3836 63.6414 70.8602 61.4381C70.2817 59.1387 69.5139 56.8637 68.6618 55.3726C66.6445 51.8423 62.3189 47.4699 58.871 48.6209C54.958 49.9271 55.2007 55.536 55.262 56.8753C55.2801 57.2692 55.3231 57.5321 55.3655 57.7919C55.3903 57.9437 55.3833 58.086 55.3507 58.2157C55.4317 58.4206 55.4956 58.6994 55.4478 59.5645L54.3509 58.9837C54.1395 58.9946 53.9172 58.9504 53.7066 58.8399L25.2483 43.9201C24.9129 43.7442 24.6357 43.4798 24.4637 43.1597L24.3644 43.1071C24.3482 43.015 24.3372 42.9226 24.3306 42.8297C24.2989 42.716 24.2798 42.5977 24.2747 42.4758C24.2543 41.9885 24.261 41.4565 24.2683 40.8853L24.2683 40.8848C24.2983 38.5112 24.3369 35.4605 22.4758 32.1268C20.7746 29.0796 18.2718 27.0487 15.974 27.7441C13.6761 28.4395 13.0282 30.8993 12.8894 32.2716C12.7531 33.6191 12.8134 34.8577 12.8485 35.5761L12.8484 35.5761C12.8625 35.8652 12.8725 36.07 12.8639 36.1638C12.834 36.4904 9.56468 33.6201 9.36363 32.5371C8.75172 29.2407 8.64847 26.1587 9.02091 22.8229C9.07221 22.3634 9.23292 21.314 9.3775 20.6709C9.4428 20.3804 9.48259 20.0816 9.48034 19.7839C9.47186 18.664 9.67795 17.2135 9.96987 16.5674C9.99858 16.5038 10.0266 16.4369 10.0561 16.3666C10.3997 15.5464 10.9364 14.2653 14.9906 12.5019C20.7474 9.99794 36.4101 4.45268 37.0152 4.32548C38.445 4.02496 40.2708 4.1788 41.749 4.30334C42.6163 4.37642 43.3639 4.43941 43.8415 4.3946C50.7452 3.74698 58.7309 4.78109 69.2298 10.2139C70.6265 10.8242 72.0063 11.5178 73.3417 12.3066C76.6731 14.2744 79.4792 16.3556 81.8145 18.2713C84.5761 20.4221 86.7006 22.3531 88.2232 23.7369C88.9001 24.3523 89.4581 24.8594 89.9002 25.2296Z",
    fill: "#F37A20"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ddi_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.1034 36.8343C58.4502 35.2791 56.3687 30.422 51.1516 24.6089C50.674 24.0767 50.8645 23.2227 51.5309 22.963L74.2183 14.1203C74.3693 14.0615 74.5313 14.0421 74.6853 14.0922C75.4233 14.3325 78.0049 15.4908 84.1088 20.967C87.4865 23.9973 88.1608 24.7845 89.9095 25.9886C90.1861 26.1791 90.1335 26.5917 89.1019 27.4243C85.8134 30.0783 67.7471 39.2369 62.1034 36.8343Z",
    fill: "url(#paint5_linear_608_176)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_di_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2787 16.3836C30.2569 14.7475 29.5444 14.8876 25.6758 14.8485C23.2788 14.8242 19.2897 14.6503 18.8643 15.7232C18.4389 16.7961 23.0047 20.2255 24.8981 21.2981C25.8235 21.8223 57.765 38.2311 56.7634 36.3199C55.5294 33.9652 49.8083 27.2168 47.8589 24.465C44.6088 19.8772 40.3005 18.0196 35.2787 16.3836Z",
    fill: "url(#paint6_linear_608_176)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_di_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8929 13.0944L45.1157 4.70312C45.1157 4.70312 44.6403 4.86527 42.0472 4.80082C41.1423 4.77832 19.1154 13.5701 18.9537 13.7093L23.8929 13.0944Z",
    fill: "url(#paint7_linear_608_176)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.6971 48.5349C63.6184 44.6808 59.1054 39.8997 54.2592 35.5221C68.7776 39.986 99.1613 49.7404 98.6775 50.3502C98.0728 51.1125 95.8744 52.0019 88.5955 52.4184C81.4293 52.8285 72.6221 48.9762 71.6971 48.5349Z",
    fill: "url(#paint8_linear_608_176)",
    fillOpacity: 0.21
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_di_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9317 37.0617C42.9336 36.8741 42.8283 36.7019 42.6607 36.6182L40.3043 35.4429C39.9803 35.2813 39.5996 35.5145 39.5959 35.8769C39.594 36.0655 39.7001 36.2387 39.8688 36.3226L42.2271 37.4942C42.5497 37.6544 42.9281 37.4221 42.9317 37.0617Z",
    fill: "#323232"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_di_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4697 30.0578C27.4716 29.8702 27.3663 29.6979 27.1986 29.6143L24.8422 28.439C24.5182 28.2774 24.1375 28.5106 24.1339 28.873C24.1319 29.0616 24.238 29.2348 24.4068 29.3187L26.765 30.4903C27.0876 30.6505 27.466 30.4182 27.4697 30.0578Z",
    fill: "#323232"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9474 33.4464L59.5836 19.7852C57.4589 20.3372 52.6153 22.4463 51.693 22.782C50.498 23.217 50.2976 23.4641 50.2976 23.4641C50.294 23.8234 50.4758 23.9824 51.048 24.5497C51.8684 25.363 52.2153 25.7371 54.2412 28.3776C57.1586 32.1802 59.372 35.7132 61.5199 36.5774C63.2286 37.2648 65.8984 37.878 69.7188 36.6604C73.1336 35.5721 75.2415 34.3246 77.9474 33.4464Z",
    fill: "#C4C4C4",
    fillOpacity: 0.2
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.17,
    filter: "url(#filter16_f_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.647 44.4561C105.566 48.3922 94.2942 53.9783 89.2785 54.7968",
    stroke: "url(#paint9_linear_608_176)",
    strokeWidth: 33.2029,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_dii_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.476 45.9437C115.427 44.6855 115.219 43.6606 115.089 42.1056C115.076 41.9497 115.039 41.7968 115.005 41.644C114.809 40.7523 116.461 43.3066 116.626 45.0903C116.683 45.7101 116.64 46.0232 116.577 46.5941C116.547 46.8552 115.993 48.4459 116.07 48.7912C116.146 49.1366 115.946 51.5097 115.955 51.8688C115.963 52.2278 114.437 54.8833 110.473 57.4191C107.179 59.5257 102.468 60.8826 101.985 60.9469C101.503 61.0113 101.047 59.3914 100.699 59.2986C99.7863 59.0558 97.0738 60.021 96.0623 60.2643C94.8821 60.5483 92.1284 61.2027 89.1303 60.7867C85.422 60.2723 84.8581 59.8445 81.4635 57.9515C80.1548 57.2218 79.0721 56.1017 78.2814 55.0286C77.4414 53.8884 78.4386 52.8384 79.7814 53.2886C82.4083 54.1695 86.2279 55.3237 90.4195 55.7963C98.6054 56.7193 105.117 52.8916 106.05 52.3413C109.972 50.0282 112.028 49.1791 114.476 45.9437Z",
    fill: "#211F1F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_608_176",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 44,
    width: 41,
    height: 17
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.48 45.9239C114.548 45.8346 114.61 45.744 114.667 45.6523C115.349 44.5537 116.846 43.8673 117.029 45.1474C117.086 45.7672 117.067 46.1602 117.004 46.7311C116.975 46.9923 116 48.4251 116.076 48.7705C116.153 49.1158 115.955 51.489 115.963 51.8481C115.972 52.2071 114.448 54.8635 110.485 57.4019C107.193 59.5106 102.482 60.8705 102 60.9352C101.517 60.9998 101.061 59.3802 100.712 59.2877C99.7994 59.0454 97.0875 60.0123 96.0762 60.2563C94.8962 60.5411 92.1429 61.1972 89.1445 60.7832C85.4359 60.2711 84.8717 59.8437 81.4759 57.9529C80.1667 57.224 79.0832 56.1046 78.2919 55.032C77.4511 53.8923 78.4477 52.8417 79.7908 53.2911C82.4182 54.1702 86.2386 55.322 90.4305 55.7919C98.617 56.7097 105.126 52.8778 106.059 52.327C109.979 50.0113 112.035 49.1609 114.48 45.9239Z",
    fill: "#999999"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_608_176)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5001 55.0474L92.824 55.232C92.7809 55.3871 92.6867 55.5738 92.4234 55.7667C92.1256 55.985 91.5451 56.2569 90.4537 56.3921C89.8584 56.4658 88.9841 56.4576 88.079 56.2764C87.1695 56.0943 86.3357 55.7592 85.727 55.2638C85.6598 55.2092 85.5835 55.1359 85.5001 55.0474Z",
    stroke: "white",
    strokeOpacity: 0.9,
    strokeWidth: 2.97403
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_608_176)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-1_608_176",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.1 42.1043C115.1 42.1043 116.376 43.8131 115.461 45.7312C115.186 46.3078 114.639 46.6032 114.098 46.1856C113.696 45.8748 112.384 46.1298 112.384 46.1298L115.1 42.1043Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.1 42.1043L117.483 40.3247L114.977 36.9693L112.634 40.4411L115.1 42.1043ZM115.461 45.7312L118.146 47.0115L115.461 45.7312ZM114.098 46.1856L112.28 48.5393L114.098 46.1856ZM112.384 46.1298L109.919 44.4666L105.903 50.4197L112.952 49.0492L112.384 46.1298ZM115.1 42.1043C112.717 43.884 112.716 43.883 112.716 43.882C112.715 43.8816 112.715 43.8806 112.714 43.88C112.713 43.8786 112.712 43.8773 112.711 43.876C112.709 43.8735 112.707 43.871 112.706 43.8686C112.702 43.8638 112.699 43.8593 112.696 43.8552C112.69 43.8468 112.685 43.8398 112.681 43.834C112.673 43.8224 112.668 43.8154 112.666 43.8129C112.663 43.8081 112.67 43.8189 112.684 43.8425C112.712 43.8942 112.751 43.9763 112.781 44.0711C112.837 44.2546 112.824 44.3528 112.777 44.4508L118.146 47.0115C119.014 45.1915 118.82 43.4763 118.467 42.3259C118.291 41.7537 118.069 41.2887 117.886 40.9601C117.794 40.7936 117.709 40.6559 117.64 40.5502C117.605 40.4971 117.574 40.4516 117.547 40.414C117.534 40.3952 117.522 40.3784 117.511 40.3635C117.506 40.356 117.501 40.3491 117.496 40.3426C117.494 40.3394 117.491 40.3363 117.489 40.3333C117.488 40.3318 117.487 40.3303 117.486 40.3289C117.485 40.3282 117.484 40.3271 117.484 40.3268C117.483 40.3257 117.483 40.3247 115.1 42.1043ZM112.777 44.4508C112.857 44.2828 113.128 43.8237 113.793 43.5628C114.148 43.4234 114.565 43.3672 114.991 43.4386C115.411 43.5087 115.721 43.6815 115.916 43.8319L112.28 48.5393C113.29 49.3195 114.654 49.6145 115.966 49.0996C117.108 48.6513 117.79 47.7562 118.146 47.0115L112.777 44.4508ZM115.916 43.8319C115.145 43.2359 114.301 43.1243 113.987 43.0897C113.565 43.0432 113.171 43.0554 112.895 43.0736C112.603 43.0928 112.343 43.1259 112.162 43.1526C112.069 43.1663 111.991 43.1792 111.932 43.1893C111.903 43.1944 111.879 43.1989 111.859 43.2024C111.849 43.2042 111.841 43.2058 111.834 43.2072C111.83 43.2078 111.827 43.2085 111.824 43.209C111.823 43.2093 111.821 43.2095 111.82 43.2098C111.82 43.2099 111.819 43.21 111.818 43.2101C111.818 43.2102 111.818 43.2103 111.817 43.2103C111.817 43.2104 111.817 43.2105 112.384 46.1298C112.952 49.0492 112.951 49.0493 112.951 49.0493C112.951 49.0494 112.951 49.0494 112.95 49.0495C112.95 49.0496 112.949 49.0497 112.949 49.0498C112.948 49.05 112.947 49.0501 112.946 49.0503C112.945 49.0506 112.943 49.0508 112.942 49.051C112.94 49.0514 112.939 49.0516 112.939 49.0516C112.939 49.0516 112.943 49.0509 112.95 49.0496C112.965 49.047 112.993 49.0424 113.029 49.0371C113.107 49.0257 113.2 49.0144 113.286 49.0088C113.388 49.0021 113.397 49.0088 113.335 49.0019C113.3 48.9981 113.192 48.9846 113.038 48.9377C112.897 48.8943 112.602 48.788 112.28 48.5393L115.916 43.8319ZM114.85 47.7931L117.565 43.7676L112.634 40.4411L109.919 44.4666L114.85 47.7931Z",
    fill: "white",
    fillOpacity: 0.9,
    mask: "url(#path-30-inside-1_608_176)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_608_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8248 47.7346L24.2258 32.4121C26.0936 36.0368 25.7032 40.0797 25.6112 41.7689L53.1806 56.2273C53.2293 51.4201 54.6823 48.1925 55.8248 47.7346Z",
    fill: "#F37A20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_608_176",
    x: 56.8466,
    y: 51.0205,
    width: 11.2961,
    height: 15.9648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.503074,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_608_176"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.251537
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_608_176",
    x: 56.2963,
    y: 52.2754,
    width: 11.1914,
    height: 14.3743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.20123
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.150922
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.50922,
    dy: 1.00615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75461
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_608_176",
    x: 57.2827,
    y: 51.2676,
    width: 10.5389,
    height: 15.4727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.369368,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_608_176"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.184684
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_608_176",
    x: 57.1407,
    y: 53.1709,
    width: 9.6127,
    height: 12.1634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.201229
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.150922
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.50922,
    dy: 1.00615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75461
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_608_176",
    x: 14.053,
    y: 29.3428,
    width: 8.57349,
    height: 13.6875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.415445,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_608_176"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.207722
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_di_608_176",
    x: 13.5278,
    y: 30.4208,
    width: 8.62048,
    height: 12.288,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.166178
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.124633
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.24633,
    dy: 0.83089
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.623167
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_608_176",
    x: 13.963,
    y: 30.3369,
    width: 8.36597,
    height: 13.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.369368,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_608_176"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.184684
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_608_176",
    x: 13.963,
    y: 30.3369,
    width: 8.36597,
    height: 13.0273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.373895,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_608_176"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.186948
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_di_608_176",
    x: 13.4938,
    y: 31.8857,
    width: 7.87137,
    height: 10.6595,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.20123
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.150922
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.41 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.50922,
    dy: 1.00615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.754611
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii_608_176",
    x: 8.8042,
    y: 0.126779,
    width: 111.225,
    height: 72.3137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.01844,
    dy: -4.02459
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0738
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_608_176"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.503074
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_608_176",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ddi_608_176",
    x: 48.8737,
    y: 12.5543,
    width: 42.1851,
    height: 26.1874,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.00615,
    dy: 0.503074
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.503074
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.503074
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.503074
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_608_176",
    result: "effect2_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.503074,
    dy: 1.50922
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.754611
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_di_608_176",
    x: 16.8241,
    y: 14.8232,
    width: 40.4826,
    height: 23.6637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.520243
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.260122
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.01229,
    dy: 2.51537
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_di_608_176",
    x: 16.9414,
    y: 4.70312,
    width: 28.6945,
    height: 11.0182,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.520244
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.260122
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0 0.925374 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.0123,
    dy: 2.51537
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.00615
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_608_176",
    x: 40.1732,
    y: 21.4364,
    width: 72.5961,
    height: 45.0989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04303,
    result: "effect1_foregroundBlur_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_di_608_176",
    x: 39.3463,
    y: 34.8916,
    width: 3.83496,
    height: 3.90187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.249514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.124757
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.24757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.623784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_di_608_176",
    x: 23.8843,
    y: 27.8877,
    width: 3.83496,
    height: 3.90187,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.249514
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.124757
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0 0.78755 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.24757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.623784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_608_176",
    x: 67.6438,
    y: 22.8228,
    width: 64.6359,
    height: 53.6083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.51537,
    result: "effect1_foregroundBlur_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_dii_608_176",
    x: 75.1505,
    y: 39.1093,
    width: 44.3245,
    height: 25.1322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.470327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.41098
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.470327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.470327
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_608_176"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.470327
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.470327
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_608_176",
    result: "effect3_innerShadow_608_176"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_608_176",
    x: 82.3223,
    y: 53.4863,
    width: 14.2501,
    height: 6.89939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.991342,
    dy: 1.23143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.615716
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_608_176",
    x: 112.144,
    y: 42.1045,
    width: 5.87009,
    height: 6.74021,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.991342,
    dy: 1.23143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.615716
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_608_176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_608_176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_608_176",
    x: 21.7307,
    y: 29.917,
    width: 36.5893,
    height: 28.8057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24757,
    result: "effect1_foregroundBlur_608_176"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_608_176",
    x1: 11.6974,
    y1: 12.8497,
    x2: 12.2798,
    y2: 4.18705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_608_176",
    x1: 10.9376,
    y1: 11.2778,
    x2: 7.6572,
    y2: -3.77742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_608_176",
    x1: 9.6605,
    y1: 10.6108,
    x2: 10.1413,
    y2: 3.45748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C5C5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_608_176",
    x1: 9.04144,
    y1: 9.3247,
    x2: 6.32862,
    y2: -3.12299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_608_176",
    x1: 13.4204,
    y1: 37.5725,
    x2: 16.3793,
    y2: 29.5749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_608_176",
    x1: 74.8914,
    y1: -6.48824,
    x2: 46.3259,
    y2: 20.0034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498386,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_608_176",
    x1: 27.5149,
    y1: 82.7166,
    x2: 55.0411,
    y2: 33.5837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498386,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_608_176",
    x1: 16.4995,
    y1: 31.5445,
    x2: 31.7933,
    y2: 9.63544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498386,
    stopColor: "#707072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F3032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_608_176",
    x1: 74.8933,
    y1: 53.2836,
    x2: 78.508,
    y2: 43.0537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_608_176",
    x1: 100.237,
    y1: 54.7957,
    x2: 97.9162,
    y2: 50.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899322,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.0d74bb0f9949f69d6b50906222740c83.svg";
export { ForwardRef as ReactComponent };